import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useRefreshTokenMutation } from '../../../services/auth_api'
import { clearAuth, setAuth } from '../../../store/auth/authSlice'

const AuthBootstrap = () => {

    const dispatch = useDispatch()
    const [refreshToken, { data, isLoading, isSuccess, isError }] = useRefreshTokenMutation()

    useEffect(() => {
        refreshToken({})
    }, [dispatch, refreshToken])

    useEffect(() => {
        if (isSuccess && data?.accessToken) {
            dispatch(setAuth({
                accessToken: data.accessToken,
                user: data.user,
                isAuth: true,
            }))
        }

        if (isError) {
            dispatch(clearAuth())
        }
    }, [isLoading, data, isSuccess, isError, dispatch, refreshToken])

    return null
}

export default AuthBootstrap